import { AppRegistration, Delete, Lock } from '@mui/icons-material';
import { Button, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useGlobals } from 'src/shared/contexts/appContext';
import { Link } from 'react-router-dom';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { Event } from '../models/event';

type EventPlaceDatePartialProps = {
  event: Event;
};

export const EventPlaceDatePartial = (props: EventPlaceDatePartialProps) => {
  const { event } = props;
  const { t } = useTranslation();

  const { currentUser } = useGlobals();

  const publicEventPageLink = `https://forms.foreningssupport.se/event/${event.guid}/${currentUser?.custName}`;

  const TableWrapper = ({ children }) => {
    return (
      <TableContainer>
        <Table
          size='small'
          sx={{
            '& th': {
              whiteSpace: 'nowrap',
              pr: '1rem !important',
            },
            '& td': {
              width: '100%',
            },
            '& td, & th': { border: 0 },
          }}
        >
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    );
  };

  const tabelRow = (label: string, value: string | undefined, removeId?: string, locked?: boolean) => {
    if (!value) return null;
    return (
      value && (
        <TableRow key={`${label}-${value}-${removeId}`}>
          <TableCell component={'th' as any} scope='row' sx={{ verticalAlign: 'top' }}>
            <Typography variant='body1' sx={{ fontWeight: 600 }}>
              {label}:
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant='body1'>{value}</Typography>
          </TableCell>
          {removeId && (
            <TableCell padding='none' sx={{ p: '0 !important' }}>
              {locked && (
                <Tooltip arrow title={<>{t('member:memberDetails.lockedProfile')}</>} placement='top'>
                  <span>
                    <IconButton size='small' disabled>
                      <Lock fontSize='small' />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              {!locked && (
                <Tooltip arrow title={<>{t('common:button.delete')}</>} placement='top'>
                  <span>
                    <IconButton size='small' onClick={() => ConsoleHelper.log(removeId)}>
                      <Delete fontSize='small' />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </TableCell>
          )}
        </TableRow>
      )
    );
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs={12}>
          <ContentSection header={t('event:place')}>
            <TableWrapper>
              {tabelRow(t('common:name'), event.locationName)}
              {tabelRow(t('event:address'), event.address)}
              {tabelRow(t('event:zipCode'), event.postcode)}
              {tabelRow(t('event:city'), event.city)}
            </TableWrapper>
          </ContentSection>
        </Grid>
        <Grid item xs={12}>
          <ContentSection header={t('event:contact')}>
            <TableWrapper>
              {tabelRow(t('event:formFields.contactPersonName'), event.contactPersonName)}
              {tabelRow(t('event:formFields.contactPersonEmail'), event.contactPersonEmail)}
              {tabelRow(t('event:formFields.contactPersonPhone'), event.contactPersonPhone)}
            </TableWrapper>
          </ContentSection>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='outlined'
            size='large'
            fullWidth
            sx={{ justifyContent: 'space-between', fontSize: (thm) => thm.typography.subtitle1.fontSize }}
            endIcon={<AppRegistration />}
            component={Link as any}
            target='_blank'
            to={publicEventPageLink}
          >
            {t('event:linkToRegistration')}
          </Button>
        </Grid>
      </GridWrapper>
    </>
  );
};
